<template>
    <div
        v-if="content"
        class="om-balloon-working-wrapper flex"
    >
        <component
            :is="iconName"
            class="om-balloon-working__icon mr-8"
        />
        <div class="om-balloon-working__item flex">
            <h4
                class="om-balloon-working__item-title text fz-16 text-bold"
                :class="titleClasses"
                @click="wasExpanded = !wasExpanded"
            >
                {{ title }}
                <span :class="['expand', {'expand--expanded': wasExpanded}]" />
            </h4>
            <p
                :class="[
                    'om-balloon-working__item-time text',
                    {'om-balloon-working__item-time--hidden': !wasExpanded}
                ]"
                v-html="content"
            />
        </div>
    </div>
</template>

<script>
import {defineComponent, ref} from 'vue';

import ClockSvg from '@/assets/images/icons/clock.svg?inline';
import ExpandSvg from '@/assets/images/icons/expand.svg?inline';
import ServicesSvg from '@/assets/images/icons/house.svg?inline';

export default defineComponent({
    name: 'OfficesBalloonExpandedItem',
    components: {
        ClockSvg,
        ExpandSvg,
        ServicesSvg,
    },
    props: {
        iconName: {
            type: String,
            default: () => 'ClockSvg',
        },
        title: {
            type: String,
            default: () => '',
        },
        content: {
            type: String,
            default: () => '',
        },
        titleClasses: {
            type: String,
            default: () => '',
        },
    },
    setup() {
        const wasExpanded = ref(false);

        return {
            wasExpanded,
        };
    },
});
</script>

<style lang="scss">
@import '@/assets/styles/components/about/offices/offices-balloon';
</style>
